/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Yes_TitleInputs */

const en_landing_how_yes_title = /** @type {(inputs: Landing_How_Yes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a yes`)
};

const pl_landing_how_yes_title = /** @type {(inputs: Landing_How_Yes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odbierz potwierdzenie`)
};

/**
* | output |
* | --- |
* | "Get a yes" |
*
* @param {Landing_How_Yes_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_yes_title = /** @type {((inputs?: Landing_How_Yes_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Yes_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_yes_title(inputs)
	return en_landing_how_yes_title(inputs)
});